import { getStyle } from '@coreui/coreui/dist/js/coreui-utilities';
import {
  CreativeStatusEnum,
  DLCEnum,
  StatusChangeRequestEnum,
  StatusInvoiceEnum,
  StatusRouteEnum,
} from './data';
import { upperCase } from 'lodash';

export const generateColor = (numberItem) => {
  let listColor = [];
  for (let i = 0; i < numberItem; i++) {
    listColor = [...listColor, `hsl(${(i * (360 / numberItem)) % 360}, 100%, 50%)`];
  }

  return listColor;
};

export const colorStatusReport = {
  sent: 'rgb(24, 144, 255)',
  revenue: 'rgb(24, 144, 255)',
  delivered: '#389e0d',
  unconfirm: '#a5aeb7',
  block: '#ff4d4f',
  failed: 'darkorange',
  replied: '#389e0d',
  optout: '#ff4d4f',
  clicked: '#389e0d',
  convertor: '#ABABAB',
  acd: '#000000',
};

export const colorChart = {
  optout: '#FABC05',
  failed: '#EA4237',
  clicked: '#4384F4',
  delivered: '#34A853',
};

export const colorChartDid = {
  50: '#fbe9e7',
  100: '#ffccbc',
  200: '#ffab91',
  300: '#ff8a65',
  400: '#ff7043',
  500: '#ff5722',
  600: '#f4511e',
  700: '#e64a19',
  800: '#d84315',
  900: '#bf360c',
};

export const colorChartImport = {
  dnc: '#46BDC6',
  landline: '#4284F4',
  imported: '#FF6D02',
  listColor: (numberItem) => generateColor(numberItem),
};

export const brandColor = {
  brandPrimary: getStyle('--primary'),
  brandSuccess: getStyle('--success'),
  brandInfo: getStyle('--info'),
  brandWarning: getStyle('--warning'),
  brandDanger: getStyle('--danger'),
  brandDark: getStyle('--dark'),
  brandClickedRate: '#1a4d2a',
  brandReplied: '#9400D3',
  brandConvertor: colorStatusReport.convertor,
};

export const genColorStatus = (status) => {
  if ([DLCEnum.status.COMPLETED, DLCEnum.status.ACTIVE].includes(status)) {
    return 'success';
  }

  if ([DLCEnum.status.FAILED, DLCEnum.status.DEACTIVATED].includes(status)) {
    return 'danger';
  }

  return 'pending';
};

export const genColorStatusRoute = (status) => {
  switch (status) {
    case StatusRouteEnum.ACTIVE:
    case StatusChangeRequestEnum.APPROVED:
    case StatusChangeRequestEnum.RELEASED:
      return 'success';

    case StatusRouteEnum.DEACTIVATED:
    case StatusChangeRequestEnum.PENDING:
      return 'pending';

    case StatusRouteEnum.DELETED:
    case StatusRouteEnum.SUSPENDED:
    case StatusChangeRequestEnum.REJECTED:
    case StatusChangeRequestEnum.FAILED:
      return 'danger';

    default:
      return 'success';
  }
};

export const genStatusInvoiceColor = (status) => {
  if (['succeeded', StatusInvoiceEnum.Succeeded, StatusInvoiceEnum.Paid].includes(status)) {
    return 'success';
  }

  if (['failed', StatusInvoiceEnum.Failed].includes(status)) {
    return 'danger';
  }

  if ([StatusInvoiceEnum.WaitPayment, StatusInvoiceEnum.Open].includes(status)) {
    return 'pending';
  }

  return 'processing';
};

export const genStatusProcessBadgeColor = (status) => {
  const colors = {
    COMPLETED: 'success',
    STOPPED: 'danger',
    ERROR: 'danger',
    PAUSED_SYSTEM_MAINTENANCE: 'danger',
    RUNNING: 'primary',
    SUCCESSFUL: 'success',
    CRASH: 'danger',
    PAUSED: 'danger',
    DISTRIBUTED: 'primary',
    MAINTAIN: 'secondary',
    INIT: 'black',
  };

  return colors?.[status] || 'secondary';
};

export const genColorByText = (status) => {
  const colors = {
    FINISHED: 'green',
    COMPLETED: 'green',
    SUCCESS: 'green',
    RUNNING: '#4384F4',
    FAILED: 'red',
  };

  return colors?.[upperCase(status)] || undefined;
};

export const simPoolStatusColor = {
  OFFLINE: '#EA4237',
  ONLINE: '#34A853',
  BURNED: '#FABC05',
  EXPIRED: '#54170b',
  DELIVERING: '#4384F4',
  SCANNED: '#2e0ecc',
  NOT_DELIVERING: '#EA4237',
  ACTIVATE: 'green',
  SENT: '#34A853',
  DELIVERED: '#4384F4',
  FAILED: '#EA4237',
};

export const genColorStatusCreative = (status) => {
  const result = {
    [CreativeStatusEnum.APPROVED]: 'success',
    [CreativeStatusEnum.PENDING]: 'pending',
    [CreativeStatusEnum.REJECTED]: 'danger',
  };

  return result?.[status] || '';
};

export const genColorByStats = (field) => {
  const mappingColors = {
    sent: colorStatusReport.sent,
    delivered: colorStatusReport.delivered,
    clicked: colorStatusReport.clicked,
    replied: colorStatusReport.replied,
    callback: colorStatusReport.replied,
    listen: colorStatusReport.replied,
    failed: colorStatusReport.failed,
    attemptFailed: colorStatusReport.block,
    block: colorStatusReport.block,
    convertor: colorStatusReport.convertor,
    revenue: colorStatusReport.revenue,
    ivrClickRate: colorStatusReport.delivered,
    ivrOptoutRate: colorStatusReport.block,
  };

  return mappingColors[field] || '';
};
